import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import CryptoPortfolio from './CryptoPortfolio'
import DetailedAnalysis from './DetailedAnalysis'

function App() {
	return (
		<Router>
			<div className='App'>
				<Routes>
					<Route path='/' element={<CryptoPortfolio />} />
					<Route path='/year' element={<DetailedAnalysis />} />
				</Routes>
			</div>
		</Router>
	)
}

export default App
